namespace RioERP.Shipping {

    @Serenity.Decorators.registerClass()
    export class ShippingTrackingNumbersExcelImportDialog extends Serenity.PropertyDialog<any, any> {
        protected getFormKey() { return "RioERP.ShippingTrackingNumbersExcelImportForm" }

        protected form = new ShippingTrackingNumbersExcelImportForm(this.idPrefix);

        constructor() {
            super();
        }

        protected getDialogTitle(): string {
            return "Excel Import";
        }

        protected getDialogButtons(): Serenity.DialogButton[] {
            return [
                {
                    text: 'Import',
                    click: () => {
                        /debugger;/
                        if (!this.validateBeforeSave())
                            return;

                        if (this.form.FileName.value == null ||
                            Q.isEmptyOrNull(this.form.FileName.value.Filename)) {
                            Q.notifyError("Please select a file!");
                            return;
                        }

                        ShippingTrackingNumbersService.ExcelImport({
                            FileName: this.form.FileName.value.Filename,
                        }, response => {
                            Q.notifyInfo(
                                'Inserted: ' + (response.Inserted || 0));

                            if (response.ErrorList != null && response.ErrorList.length > 0) {
                                Q.notifyError(response.ErrorList.join(',\r\n '));
                            }

                            this.dialogClose();
                        });
                    },
                },
                {
                    text: 'Cancel',
                    click: () => this.dialogClose()
                }
            ];
        }

    }
}